import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { otpMoreOptionsRequestParameters, otpRouteRequestParameters } from '@api/models/otpRouteRequest.model';
import { environment } from '@env/environment';
import { RouteRequestResult } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { LanguageService } from '@shared/services';
import { Observable } from 'rxjs';

const NUM_MAX_ITINERARIES = 4;

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  protected basePath = `${environment.otpRoutesUrl}`;
  private language = inject(LanguageService).currentLanguage;

  constructor(private httpClient: HttpClient) { }

  public routeRequest(routeParams: otpRouteRequestParameters, optionsParams: otpMoreOptionsRequestParameters, mode:string, locale: string = this.language() ):Observable<RouteRequestResult>{
    let params = new HttpParams()
    .set('fromPlace', routeParams.fromPlace)
    .set('toPlace', routeParams.toPlace)
    .set('arriveBy', routeParams.arriveBy.toString())
    .set('date', routeParams.date)
    .set('time', routeParams.time)
    .set('locale', locale)
    .set('showIntermediateStops', 'true')
    .set('mode', mode)
    .set('numItineraries', NUM_MAX_ITINERARIES);

    if (optionsParams){
      const entries = Object.entries(optionsParams);
      entries.forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params = params.set(key, value.toString());
        }
      })
    }
    return this.httpClient.get<RouteRequestResult>(`${this.basePath}`, { params });
  }

}
